import $ from 'jquery';

(function() { // Begin scoping function

  // FADEINS ON SCROLL
  // Slowly fade in and transition up elements marked with a ".fade-in-on-scroll" class
  // This creates a nice transition animation as we scroll up and down

  function updateFadeIns() {

    // Set the breakpoint at which elements fade in (as a percentage of window height)
    const breakpoint = 30;

    // Find current window position
    const top_of_window = $(window).scrollTop();
    const bottom_of_window = $(window).scrollTop() + $(window).height();

    // For each element with the fade in class...
    $('.fade-in-on-scroll').each(function(index) {

      const element_top = $(this).offset().top;

      // If the element is within fade-in range, mark it visible; otherwise, remove the visible class
      if (element_top + breakpoint <= bottom_of_window) {
        $(this).addClass('visible');
      } else {
        $(this).removeClass('visible');
      }

    });
  }

  // Run the updateFadeIns function on scroll
  $(window).bind('scroll', updateFadeIns);
  $(window).bind('resize', updateFadeIns);

  $(document).ready(() => {
    updateFadeIns();
  });

})(); // End scoping function
